<div class="control-panel">
    <div class="control-panel__inner">
        <div class="measurement-info">
            <h3 class="measurement-title">
                {{ currentMeasurement?.meta?.date }} - {{ currentMeasurement?.meta?.time }}
            </h3>
            <div class="device-info">
                <span>Device S/N {{ currentMeasurement?.meta?.serial }}</span>
                <span>Uploaded by {{ currentMeasurement?.meta?.uploadedBy }}</span>
                <button
                    *ngIf="currentMeasurement?.dynamicData?.isEditable"
                    (click)="openMarkerAnnotation()"
                    class="icon"
                >
                    <span class="material-symbols-rounded" aria-label="Edit"> edit </span>
                </button>
            </div>
        </div>

        <div class="control-sections">
            <!-- Selection Mode -->
            <div class="control-section">
                <label for="selectionMode">Selection Mode</label>
                <select
                    id="selectionMode"
                    class="control-select"
                    [(ngModel)]="selectionMode"
                    (change)="onSelectionModeChange()"
                >
                    <option value="select">Select</option>
                    <option value="hover">Hover</option>
                </select>
            </div>

            <!-- Amplitude Plot Size -->
            <div class="control-section">
                <label for="amplitudeSize">Amplitude Plot Size</label>
                <select
                    id="amplitudeSize"
                    class="control-select"
                    [(ngModel)]="amplitudeSize"
                    (change)="onAmplitudeSizeChange()"
                >
                    <option value="disabled">Disabled</option>
                    <option value="small">Small</option>
                    <option value="medium">Medium</option>
                    <option value="large">Large</option>
                </select>
            </div>

            <!-- Date/Time Format -->
            <div class="control-section">
                <label for="timeFormat">Date/Time Format</label>
                <select id="timeFormat" class="control-select" [(ngModel)]="timeFormat" (change)="onTimeFormatChange()">
                    <option value="absolute">Absolute</option>
                    <option value="relative">Relative</option>
                </select>
            </div>
        </div>
    </div>
</div>
